import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

if (process.env.NODE_ENV === 'production') {
    Raven
      .config('https://6315866689b745e88bebc9c90ac2458f@sentry.io/174849')
      .addPlugin(RavenVue, Vue)
      .install()
}

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'

import App from './App.vue'
import routes from './routes'

import Cookies from 'js-cookie'

import api from './api/api'

Vue.use(ElementUI)
Vue.use(VueRouter)

// 保持和Vue-Resource一样的调用方法
Vue.prototype.$http = api

const router = new VueRouter({
    mode: !!(window.history && history.pushState) ? 'history' : 'hash',
    routes
})

router.beforeEach((to, from, next) => {

    // console.log('from: %s, to: %s', from.path, to.path)
    // console.log('to: %s', JSON.stringify(to))
    let role = Cookies.get('role')

    if (to.path === '/login' || to.path === '/') {
        switch (role) {
            case 'admin':
                next({path: '/admin/student'})
                break
            case 'student':
                next({path: '/student/cope'})
                break
            case 'teacher':
                next({path: '/teacher/progress'})
                break
            default:
                next()
                break
        }
    } else {
        // 未定义role或role和当前cookie里role相同则允许访问，否则
        if (to.matched.every(record => typeof(record.meta.role) === 'undefined' || record.meta.role === role)) {
            // if (to.matched.every(record => {
            //
            //         console.log('role',role);
            //         console.log('record.meta.role',record.meta.role);
            //     return typeof(record.meta.role) === 'undefined' || record.meta.role === role
            //     })) {
            //     console.log('next')
            next()
        } else {
            // console.log('next login')
            next({path: '/login'})
        }
    }

})

// api层鉴权失败统一处理
api.interceptors.response.use(response => {
        return response
    }, error => {
        // 返回code是2的情况下，跳转到login页
        if (error.code === 2) {
            router.push('/login')
        }
        return Promise.reject(error)
    }
)


new Vue({
    router,
    render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js